import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { theme } from "./theme";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { PrismicProvider } from "@prismicio/react";
import { client } from "./prismic";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <PrismicProvider client={client}>
        <ToastContainer theme="colored" position="bottom-center" />
        <BrowserRouter>
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </PrismicProvider>
    </ThemeProvider>
  </Provider>
);
reportWebVitals();
